import styled from 'styled-components';

export const Input = styled.input`
  padding: 11px 10px;
  line-height: 22px;
  background-color: #ffffff;
  border: none;
  transition: 0.3s all;
  font-size: 16px;
  color: #444444;
  min-width: 0;
  max-width: 178px;
`;

export const InputWrapper = styled.div`
  display: flex;
  border: 1px solid #c1c1c1;
  border-radius: 3px;
  position: relative;
  align-items: center;
  ::after {
    content: '';
    display: block;
    position: absolute;
    top: calc(50% - 2px);
    right: 12px;
    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 4px 3px 0px;
    border-color: rgb(68, 68, 68) transparent transparent;
    margin-left: 10px;
  }
`;

export const DummyButton = styled.button`
  display: none;
`;

export const StyledArrowWrapper = styled.div`
  margin-left: -20px;
  margin-right: 8px;
  height: 18px;
`;
